import permissions from '@/enums/permissions';

const conciliationEdiRedeRouter = [
    {
        path: '/conciliacao-ediRede',
        name: 'conciliation-ediRede',
        component: () => import('@/views/pages/ConciliationEdiRede/ConciliationEdiRede.vue'),
        meta: {
            permissions: permissions.conciliationEdiRede,
        },
    },
];

export default conciliationEdiRedeRouter;
